(() => {
  const refreshCartCounts = async () => {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-pw-cart-count]').forEach((counter) => {
      counter.textContent = cart.item_count;
      counter.setAttribute('aria-label', `${cart.item_count} Artikel im Warenkorb`);
    });
  };

  const initStickyAtc = (bar) => {
    if (!bar || bar.dataset.pwReady === 'true') return;
    bar.dataset.pwReady = 'true';

    const variantInput = bar.querySelector('[data-pw-sticky-variant]');
    const price = bar.querySelector('[data-pw-sticky-price]');
    const submitButton = bar.querySelector('[data-pw-sticky-submit]');
    const submitLabel = submitButton?.querySelector('[data-pw-sticky-label]');
    const mainSubmit = [...document.querySelectorAll('main .product-form__submit')].find(
      (button) => !button.closest('[data-pw-sticky-atc]'),
    );

    const setVisibility = (visible) => bar.classList.toggle('is-visible', visible);

    if (mainSubmit && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => setVisibility(!entry.isIntersecting && window.scrollY > 220),
        { rootMargin: '-72px 0px 0px 0px', threshold: 0 },
      );
      observer.observe(mainSubmit);
    } else {
      const onScroll = () => setVisibility(window.scrollY > 620);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variant = data?.variant;
        if (!variant || !variantInput || !submitButton) return;

        variantInput.value = variant.id;
        variantInput.disabled = false;
        submitButton.disabled = !variant.available;

        if (submitLabel) {
          submitLabel.textContent = variant.available
            ? bar.dataset.addLabel || window.variantStrings?.addToCart || 'In den Warenkorb'
            : window.variantStrings?.soldOut || 'Ausverkauft';
        }

        const renderedPrice = data.html
          ?.querySelector?.(`#price-${data.sectionId} .price__container`)
          ?.textContent?.replace(/\s+/g, ' ')
          ?.trim();
        if (price && renderedPrice) price.textContent = renderedPrice;
      });
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-pw-sticky-atc]').forEach(initStickyAtc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCounts);
  }
})();
